import { Typography } from '@mui/material';
import { useTranslation } from "react-i18next";
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import SvgIcon from '@mui/material/SvgIcon';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SdStorageIcon from '@mui/icons-material/SdStorage';

function getProgressColor(percent) {
  if (percent >= 90) return 'error';
  if (percent >= 70) return 'warning';
  return 'success';
}

function UsageRow({ icon, label, used, max, unit }) {
  const percent = Math.min(Math.round((parseFloat(used) / parseFloat(max)) * 100), 100);
  const color = getProgressColor(percent);
  const usedRounded = Math.round(used * 10) / 10;

  return (
    <Stack spacing={0.5}>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <SvgIcon sx={{ color: 'neutral.400', fontSize: 16 }}>
          {icon}
        </SvgIcon>
        <Typography variant="caption" sx={{ color: 'neutral.400' }}>
          {label}
        </Typography>
        <Typography variant="caption" sx={{ color: 'neutral.300', ml: 'auto' }}>
          {usedRounded} / {max} {unit}
        </Typography>
      </Stack>
      <LinearProgress
        variant="determinate"
        value={percent}
        color={color}
        sx={{
          height: 4,
          borderRadius: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.08)',
        }}
      />
    </Stack>
  );
}

export default function Usage({ value, max, GoUploadedThisMonth, maxGoUploadPerMonth }) {
  const { t } = useTranslation();

  return (
    <Stack spacing={1.5}>
      <Typography variant="overline" sx={{ color: 'neutral.500' }}>
        {t("Storage")}
      </Typography>
      <UsageRow
        icon={<CalendarMonthIcon />}
        label={t("MonthlyUsage")}
        used={GoUploadedThisMonth}
        max={maxGoUploadPerMonth}
        unit={t("Momax")}
      />
      <UsageRow
        icon={<SdStorageIcon />}
        label={t("TotalStorage")}
        used={value}
        max={max}
        unit={t("Momax")}
      />
    </Stack>
  );
}
